import React, { FC } from 'react';

import { formatCurrencyValue } from '@eika/currency-input';

import { LaantypeWeb, SoeknadWeb } from '../../generated-types';
import { useTranslation } from '../../translations';

interface Props {
    soeknad: SoeknadWeb | null | undefined;
    harMedlaantaker: boolean;
}

const Soeknadsbeloep: FC<Props> = ({ soeknad, harMedlaantaker }) => {
    const { oppsummering } = useTranslation();

    return (
        <div className="row align-items">
            <span className="margin-bottom-smaller">
                {harMedlaantaker ? oppsummering.infoDereSoekerOm : oppsummering.infoDuSoekerOm}
            </span>
            <span className="number-extra-large">
                {formatCurrencyValue((soeknad?.soektBeloep || 0) + (soeknad?.eksisterendeLaanebeloep || 0))} kr
            </span>
            {soeknad?.laantype !== LaantypeWeb.KREDITT && (
                <span>{`${oppsummering.infoOver} ${
                    soeknad?.nedbetalingstid ? soeknad.nedbetalingstid / 12 : 30
                } år`}</span>
            )}
        </div>
    );
};

export default Soeknadsbeloep;
